import { CroppieOptions } from "croppie";
import * as $ from "jquery";
import { ToastrService } from "ngx-toastr";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

export class CroppedPhotoClass {
  preview_cover;
  coverImage_file: File;

  constructor(protected toastr: ToastrService) {}

  changeCover(event, type) {
    this[type + "FileCropped"] = null;
    this[type + "EditStatus"] = true;
    const fileList = event.target.files;

    if (fileList.length > 0) {
      this.coverImage_file = fileList[0];
      this.setCroppieImage(this.coverImage_file, type);
    } else {
      this.toastr.error("File type not allowed", "Error");
    }
  }

  setCroppieImage(file: File, type) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this[type + "FileCropped"] = reader.result;
    };
  }

  public get croppieOptions(): CroppieOptions {
    const opts: CroppieOptions = {};

    opts.viewport = {
      width: $(window).width(),
      height: 500,
      type: "square",
    };

    opts.boundary = {
      width: $(window).width(),
      height: 500,
    };

    opts.enforceBoundary = true;
    opts.showZoomer = false;
    opts.enableZoom = true;
    opts.mouseWheelZoom = false;

    return opts;
  }

  newImageResultFromCroppie(imgURL: string, type) {
    this[type + "FileCropped"] = imgURL;
  }

  dataURItoBlob(dataURI, imgName, imgType) {
    const code = dataURI.split(",");
    const byteString = atob(code[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([arrayBuffer], { type: imgType });

    return new File([blob], imgName, { type: imgType });
  }

  uploadCover(userId) {}

  cancelChange(type) {
    this[type + "EditStatus"] = false;
    this[type + "FileCropped"] = null;
  }

  ngOnChanges(changes: any) {
    if (!changes.imageUrl) {
      return;
    }

    if (!changes.imageUrl.previousValue && changes.imageUrl.currentValue) {
      this.preview_cover = changes.imageUrl.currentValue;
    }
  }
}
